import React, { useState } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";

import AboutUsImg from "../../assets/images/image2.webp";
import AboutUsImg_LQ from "../../assets/images/image2_lq.webp";

import MissionImg from "../../assets/images/image3.webp";
import MissionImg_LQ from "../../assets/images/image3_lq.webp";

import VisionImg from "../../assets/images/image4.webp";
import VisionImg_LQ from "../../assets/images/image4_lq.webp";

import 'react-lazy-load-image-component/src/effects/blur.css';
import FAQSection from "../../components/Tasker/FAQSection";
import { generalQuestions } from "../../constants/commonConstants";

const AboutUs = () => {

  const navigate = useNavigate();

  const [loadedHero, setLoadedHero] = useState(false);
  const [loadedMission, setLoadedMission] = useState(false);
  const [loadedVision, setLoadedVision] = useState(false);
  
  return (
    <div className="mt-12 px-[20px] min-w-[320px] md:px-[40px] lg:px-[100px]">
      <div className="flex flex-col justify-between">
        <div className={twMerge("flex w-full h-[300px] sm:h-[400px] lg:h-[520px] rounded-[20px]", loadedHero ? "bg-transparent" : "bg-gray-300 animate-pulse")}>
          <LazyLoadImage
            src={AboutUsImg}
            placeholderSrc={AboutUsImg_LQ}
            alt="About Us"
            className="w-full rounded-[20px] object-cover h-[300px] sm:h-[400px] lg:h-[520px]"
            effect="blur"
            onLoad={() => {
              setLoadedHero(true);
            }}
          />
        </div>

        <div className="flex items-center lg:items-start flex-col w-full gap-6 py-10 sm:gap-8 lg:gap-10">
          <h1 className="font-nonito_sans font-bold text-3xl sm:text-4xl lg:text-level-1 leading-tight sm:leading-[1.2] lg:leading-[56px] text-primary tracking-[0.042em] text-center lg:text-left">
            Discover Reliable Services, Anytime, Anywhere
          </h1>

          <p className="font-inter font-medium text-base sm:text-level-5 leading-relaxed text-content text-center lg:text-justify max-w-2xl lg:max-w-none mx-auto lg:mx-0 tracking-[0.5px]">
            Transforming how people connect, collaborate, and get things done.
            At JumaConnect, we believe in empowering individuals and businesses
            to thrive by bridging the gap between those who need jobs completed
            and skilled service providers ready to deliver. Whether you’re
            looking for a reliable handyman, a talented graphic designer, a
            cleaner, or help with everyday errands, we’re here to make the
            process seamless, secure, and efficient.
          </p>

          <button
            onClick={() => navigate("/client/find-service-pro")}
            className="bg-primary flex items-center justify-center text-tertiary font-inter font-semibold text-[16px] leading-[17px] w-full sm:w-[214px] h-[49px] rounded-xl hover:bg-primary/90 transition-colors"
          >
            Find a Service-Pro
          </button>
        </div>
      </div>
      <div className="w-full py-8 sm:py-12 lg:py-[88px] z-10">
        <div className=" flex flex-col items-center lg:flex-row min-h-[506px] lg:relative">
          <div className="relative lg:absolute z-10 w-full lg:w-[640px] flex flex-col gap-4 mb-6 lg:mb-0">
            <div className="bg-white rounded-[20px] border-b-2 border-[#DDE1E6] lg:min-h-[257px] sm:min-h-[200px] p-6 lg:p-10">
              <h1 className="font-nonito_sans text-primary text-3xl sm:text-4xl lg:text-level-1 leading-tight lg:leading-[60px] font-bold mb-6 sm:mb-8 lg:mb-10 text-center lg:text-left">
                Our Mission
              </h1>
              <p className="font-inter font-medium text-base sm:text-level-5 leading-relaxed text-content text-center lg:text-left max-w-2xl lg:max-w-none mx-auto lg:mx-0 tracking-[0.5px]">
                At Jumaconnect, our mission is to empower individuals and businesses across by providing a seamless, reliable, and affordable platform for task-based services. We connect skilled professionals with clients who need their expertise, ensuring quality, trust, and convenience in every interaction. Through innovation and a commitment to excellence, we aim to create economic opportunities, enhance productivity, and transform how people get things done.
              </p>
            </div>
          </div>

          <div className="relative lg:absolute right-0 w-full lg:w-[791px] h-[300px] sm:h-[400px] lg:h-[506px] ">
            <div className={twMerge("flex w-full h-[100%] rounded-[20px]", loadedMission ? "bg-transparent" : "bg-gray-300 animate-pulse")}>
              <LazyLoadImage
                src={MissionImg}
                placeholderSrc={MissionImg_LQ}
                alt="Service illustration"
                className="w-full h-full object-cover rounded-[20px]"
                effect="blur"
                onLoad={() => {
                  setLoadedMission(true);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full py-8 sm:py-12 lg:py-[88px] z-10">
        <div className=" flex flex-col items-center lg:flex-row min-h-[506px] lg:relative">
          <div className="relative  lg:absolute left-0 w-full lg:w-[791px] h-[300px] sm:h-[400px] lg:h-[506px] ">
            <div className={twMerge("flex w-full h-[100%] rounded-[20px]", loadedVision ? "bg-transparent" : "bg-gray-300 animate-pulse")}>
              <LazyLoadImage
                src={VisionImg}
                placeholderSrc={VisionImg_LQ}
                alt="Service illustration"
                className="w-full h-full object-cover rounded-[20px]"
                effect="blur"
                onLoad={() => {
                  setLoadedVision(true);
                }}
              />
            </div>
          </div>

          <div className="relative lg:absolute right-0 z-10 w-full lg:w-[640px] flex flex-col gap-4 mb-6 lg:mb-0 max-lg:mt-6">
            <div className="bg-white rounded-[20px] border-b-2 border-[#DDE1E6] lg:min-h-[257px] sm:min-h-[200px] p-6 lg:p-10 ">
              <h1 className="font-nonito_sans text-primary text-3xl sm:text-4xl lg:text-level-1 leading-tight lg:leading-[60px] font-bold mb-6 sm:mb-8 lg:mb-10 text-center lg:text-left">
                Our Vision
              </h1>
              <p className="font-inter font-medium text-base sm:text-level-5 leading-relaxed text-content text-center lg:text-left max-w-2xl lg:max-w-none mx-auto lg:mx-0 tracking-[0.5px]">
                Our vision is to become Africa’s leading platform for task-based services, revolutionizing how people find and hire skilled professionals. We strive to build a trusted, technology-driven ecosystem that creates jobs, supports businesses, and enhances everyday convenience. By expanding across the continent, we aim to empower millions with economic opportunities while setting the standard for reliability, efficiency, and customer satisfaction in the gig economy.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-20">
        <FAQSection questions={generalQuestions}/>
      </div>
    </div>
  );
};

export default AboutUs;
